export const MORPHO_TOKEN_BASE_ADDRESS =
  '0xBAa5CC21fd487B8Fcc2F632f3F4E8D37262a0842' as const;
